import React from 'react'
import { graphql } from 'gatsby'
import Img from 'gatsby-image'
import ReactFullpage from '@fullpage/react-fullpage'
import smoothscroll from 'smoothscroll-polyfill'
import Layout from '../components/layout'
import Header from '../components/header'
import arrowUp from '../images/icons/arrow-up.svg'
import arrowDown from '../images/icons/arrow-down.svg'
import arrowUpWhite from '../images/icons/arrow-up-white.svg'
import arrowDownWhite from '../images/icons/arrow-down-white.svg'
import questionMarker from '../images/icons/question-marker.svg'
import questionMarkerWhite from '../images/icons/question-marker-white.svg'


const sortByValue = jsObj => {
  var sortedArray = []
  for (var i in jsObj) {
    // Push each JSON Object entry in array by [value, key]
    sortedArray.push([jsObj[i], i])
  }
  return sortedArray.sort()
}

const handleResultsClick = e => {
  e.preventDefault()
  let score = {
    analytics: 0,
    consulting: 0,
    design: 0,
    digital: 0,
    implementation: 0,
    research: 0,
  }
  document.querySelectorAll('.answers input:checked').forEach(input => {
    for (var category in score) {
      if (score.hasOwnProperty(category)) {
        score[category] += Number(input.getAttribute('data-score-' + category))
      }
    }
  })
  let scoreSorted = sortByValue(score)
  let primary = scoreSorted.pop()[1]
  let secondary = scoreSorted.pop()[1]
  let tertiary = scoreSorted.pop()[1]
  console.log(score)
  console.log('primary:', primary)
  console.log('secondary:', secondary)
  console.log('tertiary:', tertiary)
  let path = window.location.pathname.replace('index.html', '')
  window.location = `${path}results/${primary}-${secondary}-${tertiary}/index.html`
}

const IndexPage = ({ data }) => (
  <Layout>
    <ReactFullpage
      css3="true"
      fixedElements=".question-nav"
      normalScrollElements=".answers" // dissalows scrolling when hovering over options
      recordHistory="false"
      responsiveWidth="768"
      licenseKey="99013373-38254EA6-BED3A887-1B9E5E09"
      onLeave={(origin, destination, direction) => {
        // console.log("onLeave event", { origin, destination, direction }) // eslint-disable-line no-console
        if (direction === 'down' && destination.index === 1) {
          document.getElementsByTagName('header')[0].classList.add('is-hidden')
        }

        // update question nav style
        if (destination.index === 0) {
          document
            .getElementById('question-nav-light')
            .classList.add('is-hidden')
          document
            .getElementById('question-nav-dark')
            .classList.add('is-hidden')
          document
            .getElementsByTagName('header')[0]
            .classList.remove('is-hidden')
        } else {
          let destinationSection = document.getElementsByClassName('section')[
              destination.index
            ],
            lightNav = document.getElementById('question-nav-light'),
            darkNav = document.getElementById('question-nav-dark')

          if (destinationSection.classList.contains('bg-blue')) {
            lightNav.classList.remove('is-hidden')
            darkNav.classList.add('is-hidden')
          } else {
            lightNav.classList.add('is-hidden')
            darkNav.classList.remove('is-hidden')
          }

          if (destination.index === 10) {
            document
              .getElementById('question-nav-light')
              .classList.add('at-bottom')
            document
              .getElementById('question-nav-dark')
              .classList.add('at-bottom')
          }
        }
      }}
      afterLoad={(origin, destination, direction) => {
        // console.log("afterLoad event", { origin, destination, direction }) // eslint-disable-line no-console

        if (direction === 'up' && destination.index === 9) {
          document
            .getElementById('question-nav-light')
            .classList.remove('at-bottom')
          document
            .getElementById('question-nav-dark')
            .classList.remove('at-bottom')
        }

        // scroll down to ensure results cta is visible
        let resultsCta = document.getElementById('resultsCta')
        if (resultsCta && resultsCta.classList.contains('scroll-to-bottom')) {
          window.scrollTo(0, document.body.scrollHeight)
        }
      }}
      afterRender={() => {
        // randomize order of answers
        let answers = document.getElementsByClassName('answers')
        for (var i = 0; i < answers.length; i++) {
          for (var j = answers[i].children.length; j >= 0; j--) {
            answers[i].appendChild(answers[i].children[(Math.random() * j) | 0])
          }
        }
        smoothscroll.polyfill()
      }}
      render={({ state, fullpageApi }) => {
        let { sectionCount, destination } = state
        let currentSection = destination && destination.index

        // console.log('render prop change', state, fullpageApi) // eslint-disable-line no-console
        return (
          <ReactFullpage.Wrapper>
            <Header fullpageApi={fullpageApi} />
              <div data-layer-region="careers-quiz">
                <div className="question-nav is-hidden" id="question-nav-dark">
                  <button
                    className="arrow arrow-up"
                    onClick={() => fullpageApi.moveSectionUp()}
                  >
                    <img src={arrowUp} alt="Previous Question" />
                  </button>
                  <button
                    to="#"
                    className="arrow arrow-down"
                    onClick={() => fullpageApi.moveSectionDown()}
                  >
                    <img src={arrowDown} alt="Next Question" />
                  </button>
                </div>
                <div className="question-nav is-hidden" id="question-nav-light">
                  <button
                    className="arrow arrow-up"
                    onClick={() => fullpageApi.moveSectionUp()}
                  >
                    <img src={arrowUpWhite} alt="Previous Question" />
                  </button>
                  <button
                    to="#"
                    className="arrow arrow-down"
                    onClick={() => fullpageApi.moveSectionDown()}
                  >
                    <img src={arrowDownWhite} alt="Next Question" />
                  </button>
                </div>
                <div className="section section-hero">
                  <Img
                    className="background-image"
                    fluid={data.imageHero.childImageSharp.fluid}
                  />
                  <div className="outer-wrapper">
                    <div className="content-wrapper">
                      <h1>
                        Explore
                        <br />
                        McKinsey Careers
                      </h1>
                      <p>
                        Take this quick 10-question quiz to discover the career path
                        at McKinsey that best fits you.
                      </p>
                      <button
                        className="btn btn-fill"
                        data-layer-event-prefix="UI Item"
                        data-layer-action="click"
                        data-layer-category="interactive"
                        onClick={() => fullpageApi.moveSectionDown()}
                      >
                        Find Your Fit
                      </button>
                    </div>
                    <div className="timeline" />
                  </div>
                </div>

                {data.allQuestionsJson.edges.map(({ node }, nodeNum) => (
              <section
                key={node.id}
                className={
                  'fp-auto-height-responsive section section-question ' +
                  node.modifiers
                }
                id={'question-' + nodeNum}
              >
                <div className="timeline" />
                <div className={'indicator marker-color-' + node.markerColor}>
                  <img
                    className="question-marker question-marker-blue"
                    alt=""
                    src={questionMarker}
                  />
                  <img
                    className="question-marker question-marker-white"
                    alt=""
                    src={questionMarkerWhite}
                  />
                  <div className="counter">
                    <span>{('00' + node.num).substr(-2, 2)}</span>/
                    <span>10</span>
                  </div>
                </div>
                <div className="inner-wrapper">
                  <div className="content-wrapper">
                    <div className="background-image">
                      {node.num === 1 && (
                        <>
                          <Img
                            fluid={data.imageOne.childImageSharp.fluid}
                            className="hide-for-mobile"
                          />
                          <Img
                            fluid={data.imageOneMobile.childImageSharp.fluid}
                            className="hide-for-desktop"
                          />
                        </>
                      )}
                      {node.num === 2 && (
                        <>
                          <Img
                            fluid={data.imageTwo.childImageSharp.fluid}
                            className="hide-for-mobile"
                          />
                          <Img
                            fluid={data.imageTwoMobile.childImageSharp.fluid}
                            className="hide-for-desktop"
                          />
                        </>
                      )}
                      {node.num === 3 && (
                        <>
                          <Img
                            fluid={data.imageThree.childImageSharp.fluid}
                            className="hide-for-mobile"
                          />
                          <Img
                            fluid={data.imageThreeMobile.childImageSharp.fluid}
                            className="hide-for-desktop"
                          />
                        </>
                      )}
                      {node.num === 4 && (
                        <>
                          <Img
                            fluid={data.imageFour.childImageSharp.fluid}
                            className="hide-for-mobile"
                          />
                          <Img
                            fluid={data.imageFourMobile.childImageSharp.fluid}
                            className="hide-for-desktop"
                          />
                        </>
                      )}
                      {node.num === 5 && (
                        <>
                          <Img
                            fluid={data.imageFive.childImageSharp.fluid}
                            className="hide-for-mobile"
                          />
                          <Img
                            fluid={data.imageFiveMobile.childImageSharp.fluid}
                            className="hide-for-desktop"
                          />
                        </>
                      )}
                      {node.num === 6 && (
                        <>
                          <Img
                            fluid={data.imageSix.childImageSharp.fluid}
                            className="hide-for-mobile"
                          />
                          <Img
                            fluid={data.imageSixMobile.childImageSharp.fluid}
                            className="hide-for-desktop"
                          />
                        </>
                      )}
                      {node.num === 7 && (
                        <>
                          <Img
                            fluid={data.imageSeven.childImageSharp.fluid}
                            className="hide-for-mobile"
                          />
                          <Img
                            fluid={data.imageSevenMobile.childImageSharp.fluid}
                            className="hide-for-desktop"
                          />
                        </>
                      )}
                      {node.num === 9 && (
                        <>
                          <Img
                            fluid={data.imageNine.childImageSharp.fluid}
                            className="hide-for-mobile"
                          />
                          <Img
                            fluid={data.imageNineMobile.childImageSharp.fluid}
                            className="hide-for-desktop"
                          />
                        </>
                      )}
                      {node.num === 10 && (
                        <>
                          <Img
                            fluid={data.imageTen.childImageSharp.fluid}
                            className="hide-for-mobile"
                          />
                          <Img
                            fluid={data.imageTenMobile.childImageSharp.fluid}
                            className="hide-for-desktop"
                          />
                        </>
                      )}
                    </div>
                    <div className="question-content">
                      <h2 className="question">{node.value}</h2>
                      <div
                        className={'answers answers-' + node.answerType}
                        id={'fieldset-' + node.num}
                        data-section={node.num}
                      >
                        {node.answers.map(({ answer }, count) => (
                          <div key={answer.value}>
                            <input
                              type={node.answerType}
                              id={'q' + node.num + 'a' + count}
                              ref={'q' + node.num + 'a' + count}
                              name={node.answerType + '-group-q' + node.num}
                              data-score-implementation={
                                answer.weights.implementation
                              }
                              data-score-consulting={answer.weights.consulting}
                              data-score-research={answer.weights.research}
                              data-score-analytics={answer.weights.analytics}
                              data-score-digital={answer.weights.digital}
                              data-score-design={answer.weights.design}
                            />
                            <label
                              htmlFor={'q' + node.num + 'a' + count}
                              data-checked={false}
                              onClick={event => {
                                let target = event.target
                                let animationIsFinished = false
                                let isChecked = target.previousSibling.checked
                                let fieldset = document.getElementById(
                                  'fieldset-' + node.num
                                )
                                let validMax = 3
                                let thisQuestionIsAnswered = false
                                let numChecked = document
                                  .getElementById('fieldset-' + node.num)
                                  .querySelectorAll(':checked').length
                                let resultsCta = document.getElementById(
                                  'resultsCta'
                                )

                                if (node.answerType === 'radio') {
                                  thisQuestionIsAnswered = true
                                  fieldset.classList.add('is-answered')
                                } else if (node.answerType === 'checkbox') {
                                  if (!isChecked) {
                                    // console.log('was not checked')
                                    if (numChecked === validMax - 1) {
                                      thisQuestionIsAnswered = true
                                      fieldset.classList.add('is-answered')
                                    } else if (numChecked === validMax) {
                                      thisQuestionIsAnswered = true
                                      let uncheckedInputs = fieldset.querySelectorAll(
                                        'input:not(:checked)'
                                      )
                                      uncheckedInputs.forEach(input => {
                                        input.setAttribute('disabled', true)
                                      })
                                    }
                                  } else {
                                    // console.log('was already checked')
                                    let uncheckedInputs = fieldset.querySelectorAll(
                                      'input:not(:checked)'
                                    )
                                    uncheckedInputs.forEach(input => {
                                      input.removeAttribute('disabled')
                                    })
                                    fieldset.classList.remove('is-answered')
                                  }
                                }

                                if (!thisQuestionIsAnswered) {
                                  resultsCta.classList.add('is-hidden')
                                  return
                                }

                                let unansweredQuestions = document.querySelectorAll(
                                  '.answers:not(.is-answered)'
                                )
                                let nextUnansweredQuestion = Array.from(
                                  unansweredQuestions
                                ).filter((currentValue, index) => {
                                  return (
                                    parseInt(
                                      currentValue.getAttribute('data-section')
                                    ) > node.num
                                  )
                                })

                                let timeoutId = setTimeout(() => {
                                  animationIsFinished = true
                                  if (nextUnansweredQuestion.length > 0) {
                                    let nextSectionNum = parseInt(
                                      nextUnansweredQuestion[0].getAttribute(
                                        'data-section'
                                      )
                                    )
                                    // handle when mobile is already scrolled into next section
                                    if (currentSection > node.num) {
                                      document.getElementById('question-' + node.num).scrollIntoView({ behavior: 'smooth' })
                                    } else {
                                      fullpageApi.moveTo(nextSectionNum + 1)
                                    }
                                    
                                  } else if (unansweredQuestions.length > 0) {
                                    let nextSectionNum = parseInt(
                                      unansweredQuestions[0].getAttribute(
                                        'data-section'
                                      )
                                    )
                                    fullpageApi.moveTo(nextSectionNum + 1)
                                  } else {
                                    let alreadyOnLastQuestion =
                                      fullpageApi.getActiveSection().index ===
                                      sectionCount - 1

                                    resultsCta.classList.remove('is-hidden')

                                    if (alreadyOnLastQuestion) {
                                      window.scrollTo(
                                        0,
                                        document.body.scrollHeight
                                      )
                                    } else {
                                      resultsCta.classList.add(
                                        'scroll-to-bottom'
                                      )
                                      fullpageApi.moveTo(sectionCount)
                                    }
                                  }

                                  clearTimeout(timeoutId)
                                }, 400)

                                return animationIsFinished
                              }}
                            >
                              {answer.value}
                            </label>
                          </div>
                        ))}
                      </div>
                      {parseInt(node.num) + 1 === sectionCount && (
                        <button
                            id="resultsCta"
                            className="btn btn-fill btn-secondary results-cta is-hidden"
                            data-layer-event-prefix="UI Item"
                            data-layer-action="click"
                            data-layer-category="interactive"
                            onClick={handleResultsClick}
                        >
                          Finished! View my results
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </section>
            ))}
            </div>
          </ReactFullpage.Wrapper>
        )
      }}
    />
  </Layout>
)

export const query = graphql`
  {
    allQuestionsJson {
      totalCount
      edges {
        node {
          id
          num
          value
          image
          markerColor
          modifiers
          answerType
          answers {
            answer {
              value
              weights {
                implementation
                consulting
                research
                analytics
                digital
                design
              }
            }
          }
        }
      }
    }
    imageHero: file(relativePath: { eq: "quiz/hero.jpg" }) {
      ...image
    }
    imageHeroMobile: file(relativePath: { eq: "quiz/mobile/hero.jpg" }) {
      ...imageMobile
    }
    imageOne: file(relativePath: { eq: "quiz/q1.jpg" }) {
      ...image
    }
    imageTwo: file(relativePath: { eq: "quiz/q2.jpg" }) {
      ...image
    }
    imageThree: file(relativePath: { eq: "quiz/q3.jpg" }) {
      ...image
    }
    imageFour: file(relativePath: { eq: "quiz/q4.jpg" }) {
      ...image
    }
    imageFive: file(relativePath: { eq: "quiz/q5.jpg" }) {
      ...image
    }
    imageSix: file(relativePath: { eq: "quiz/q6.jpg" }) {
      ...image
    }
    imageSeven: file(relativePath: { eq: "quiz/q7.jpg" }) {
      ...image
    }
    imageNine: file(relativePath: { eq: "quiz/q9.jpg" }) {
      ...image
    }
    imageTen: file(relativePath: { eq: "quiz/q10.jpg" }) {
      ...imageMobile
    }
    imageOneMobile: file(relativePath: { eq: "quiz/mobile/q1.jpg" }) {
      ...imageMobile
    }
    imageTwoMobile: file(relativePath: { eq: "quiz/mobile/q2.jpg" }) {
      ...imageMobile
    }
    imageThreeMobile: file(relativePath: { eq: "quiz/mobile/q3.jpg" }) {
      ...imageMobile
    }
    imageFourMobile: file(relativePath: { eq: "quiz/mobile/q4.jpg" }) {
      ...imageMobile
    }
    imageFiveMobile: file(relativePath: { eq: "quiz/mobile/q5.jpg" }) {
      ...imageMobile
    }
    imageSixMobile: file(relativePath: { eq: "quiz/mobile/q6.jpg" }) {
      ...imageMobile
    }
    imageSevenMobile: file(relativePath: { eq: "quiz/mobile/q7.jpg" }) {
      ...imageMobile
    }
    imageNineMobile: file(relativePath: { eq: "quiz/mobile/q9.jpg" }) {
      ...imageMobile
    }
    imageTenMobile: file(relativePath: { eq: "quiz/mobile/q10.jpg" }) {
      ...image
    }
  }
`

export default IndexPage
